import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchElearning(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('elearning_kurse')
    .select('id, titel, beschreibung, dozent, kategorie, level, updated_at')
    .or(`titel.ilike.${pattern},beschreibung.ilike.${pattern},dozent.ilike.${pattern}`)
    .eq('ist_aktiv', true)
    .limit(serverLimit);

  if (error) {
    console.error('E-Learning search error:', error);
    return [];
  }

  return (data || [])
    .filter(e => matchFn(term, e.titel, e.beschreibung, e.dozent, e.kategorie))
    .slice(0, limit)
    .map(e => {
      const title = e.titel || 'Kurs';
      const subtitle = [e.dozent, e.kategorie].filter(Boolean).join(' • ');
      
      return {
        id: e.id,
        type: 'elearning' as SearchSectionId,
        title,
        subtitle,
        badge: e.level || 'Kurs',
        data: e,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, e.updated_at)
      };
    });
}
